import { MapPin } from "lucide-react";
import { Button } from "@/Components/ui/button";
import KakaoMapIcon from "@/assets/icons/kakaomap.svg";
import NaverMapIcon from "@/assets/icons/navermap.svg";
import {
  getKakaoMapUrl,
  getNaverMapUrl,
  resolvePreferredMapUrl,
  type MapCoordinate,
} from "@/utils/mapLinks";

interface DirectionsSectionProps {
  address?: string | null;
  siteName?: string | null;
  coordinate?: MapCoordinate | null;
  kakaoPlaceUrl?: string | null;
  naverPlaceUrl?: string | null;
}

export function DirectionsSection({
  address,
  siteName,
  coordinate,
  kakaoPlaceUrl,
  naverPlaceUrl,
}: DirectionsSectionProps) {
  const kakaoMapUrl = resolvePreferredMapUrl(
    kakaoPlaceUrl,
    getKakaoMapUrl(siteName, coordinate),
  );
  const naverMapUrl = resolvePreferredMapUrl(
    naverPlaceUrl,
    getNaverMapUrl(address),
  );

  if (!address && !kakaoMapUrl && !naverMapUrl) return null;

  return (
    <div className="p-0">
      <h3 className="text-lg font-bold mb-3 text-black">찾아오시는 길</h3>
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        {address ? (
          <div className="flex items-start gap-2">
            <MapPin size={16} className="mt-0.5 shrink-0 text-gray-400" />
            <span className="text-sm text-gray-600">{address}</span>
          </div>
        ) : (
          <div />
        )}

        <div className="flex flex-wrap gap-3">
          {kakaoMapUrl ? (
            <Button
              asChild
              variant="ghost"
              className="h-8 rounded-xl gap-1 px-2 text-xs font-bold"
            >
              <a href={kakaoMapUrl} target="_blank" rel="noopener noreferrer">
                <img src={KakaoMapIcon} alt="kakao map" className="h-5 w-5" />
                카카오
              </a>
            </Button>
          ) : null}
          {naverMapUrl ? (
            <Button
              asChild
              variant="ghost"
              className="h-8 rounded-xl gap-1 px-2 text-xs font-bold"
            >
              <a href={naverMapUrl} target="_blank" rel="noopener noreferrer">
                <img src={NaverMapIcon} alt="naver map" className="h-5 w-5" />
                네이버
              </a>
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
